import React from 'react'
import { useState } from 'react'
import UsuariosExternos from './UsuariosExternos'
import RegistroUsuarioExterno from './RegistroUsuarioExterno'

const AuxiliarRegistro = () => {

    const [userExiste, setUserExiste] = useState(false);
    const [dataUser, setDataUser] = useState(false);

    const userExist = (userValue) => {
      
      setUserExiste(userValue);
    }

    const data = (infoUser) =>{
        setDataUser(infoUser);
    }
  return (
    <>
        {!userExiste && <UsuariosExternos data={data} userExist={userExist}/>}
        {userExiste && <RegistroUsuarioExterno dataUser={dataUser} />}
       
    </>
  )
}

export default AuxiliarRegistro